export default function pxToRem(value, fontSize = 16) {
    return `${value / fontSize}rem`;
  }
  